import Registry from "@core/registry";
export var LDProject;
(function(LDProject) {
    LDProject[LDProject["SEARCH_PAGES"] = 0] = "SEARCH_PAGES";
    LDProject[LDProject["PLATFORM"] = 1] = "PLATFORM";
    LDProject[LDProject["CUSTOMER_SERVICE"] = 2] = "CUSTOMER_SERVICE";
    LDProject[LDProject["SEARCH_INTERFACES"] = 3] = "SEARCH_INTERFACES";
    LDProject[LDProject["COMMERCE_SERVICE"] = 4] = "COMMERCE_SERVICE";
})(LDProject || (LDProject = {}));
/**
 * Returns the correct LaunchDarkly project client.
 *
 * @param {LaunchDarkly | undefined} launchDarkly The LaunchDarkly instance.
 * @param {LDProject} project
 *
 * @returns {LaunchDarklyProject | undefined} The LaunchDarkly project client or undefined.
 */ var getProjectClient = function(launchDarkly, project) {
    if (!launchDarkly) {
        return undefined;
    }
    switch(project){
        case LDProject.COMMERCE_SERVICE:
            return launchDarkly.commerceService;
        case LDProject.CUSTOMER_SERVICE:
            return launchDarkly.customerService;
        case LDProject.SEARCH_PAGES:
            return launchDarkly.searchPages;
        case LDProject.SEARCH_INTERFACES:
            return launchDarkly.searchInterfaces;
        case LDProject.PLATFORM:
        default:
            return launchDarkly.platform;
    }
};
export var LaunchDarklyFeatureFlags = {
    /**
     * Checks whether a feature flag is active.
     *
     * **Important Note:**
     * - This helper is intended for *simple* boolean/string flags where a
     * true/false or non-empty/empty string check is sufficient.
     *
     * For more complex flag evaluations, use {@link getValue} instead.
     *
     * @param {string} flag The feature flag to check.
     * @param {LDProject} [project=LDProject.PLATFORM] The project to check the flag against.
     * @returns {boolean} True if the flag is active, false otherwise.
     */ isActive: function(flag) {
        var project = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : LDProject.PLATFORM;
        try {
            var launchDarkly = Registry.get("launchDarkly");
            var ldProject = getProjectClient(launchDarkly, project);
            return Boolean(ldProject === null || ldProject === void 0 ? void 0 : ldProject.checkFeatureFlag(flag));
        } catch (e) {
            return false;
        }
    },
    getProjectClient: getProjectClient
};

//# sourceMappingURL=LaunchDarklyFeatureFlags.js.map